import { get, post } from '@/utils/apiBase.js';
// 任务列表
const getTaskList = (option) => {
    return get('/apis/project/cp/get_task_list', option)
}
// 领取金币
export const postReceiveCoins = (option) => {
    return post('/apis/project/cp/receive_coins', option);
};
// 金币余额
const getCoinBlance = (option) => {
    return get('/wallet/apis/coin/balance', option)
}
// 金币交易明细
const getCoinHistory = (option) => {
    return get('/wallet/apis/coin/history', option)
}
// 获取众筹更新任务提示类型
const getUpdatetaskType = (option) => {
    return get('/apis/project/cp/pro_update_task_type', option)
}
// 推广服务列表
const getPromotionList = (option) => {
    return get('/apis/project/cp/promotion_list', option)
}
// 用户兑换的推广服务列表 
const getPromotionRecordList = (option) => {
    return get('/apis/project/cp/user_promotion_record_list', option)
}
// 用户已兑换的推广详情
const getPromotionRecordDetail = (option) => {
    return get('/apis/project/cp/user_promotion_record_detail', option)
}
// 兑换任务信息
const getPromotionDetail = (option) => {
    return get('/apis/project/cp/promotion_detail', option)
}
// 推广服务兑换
export const postPromotion = (option) => {
    return post('/apis/project/cp/promotion', option);
};
// 取消预约推广服务
export const postCancelPromotion = (option) => {
    return post('/apis/project/cp/cancel_promotion', option);
};
// 完成项目分享、视频教程任务
export const postCompleteTask = (option) => {
    return post('/apis/project/cp/complete_task', option);
};
// 获取活动任务列表
const getActivityTaskList = (option) => {
    return get('/apis/project/cp/get_activity_task_list', option)
}
// 获取符合小红书种草活动的项目信息
const getPotatoProInfo = (option) => {
    return get('/apis/project/cp_admin/rednote_task_pro_info', option)
}
export default {
    getTaskList,
    postReceiveCoins,
    getCoinBlance,
    getCoinHistory,
    getUpdatetaskType,
    getPromotionList,
    getPromotionRecordList,
    getPromotionRecordDetail,
    getPromotionDetail,
    postPromotion,
    postCancelPromotion,
    postCompleteTask,
    getActivityTaskList,
    getPotatoProInfo
};